<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="page-header">
        <div class="container">
          <div class="d-flex flex-wrap align-items-center text-white" style="padding: 32px 0; gap: 12px;">
            <div class="header-icon-wrap"><i class="fe fe-users" style="font-size: 22px;"></i></div>
            <div class="flex-grow-1">
              <h4 class="mb-0 font-weight-bold">Enrollment Officers</h4>
              <small style="opacity: 0.8;">{{ meta.total }} officer{{ meta.total == 1 ? "" : "s" }} · add officers and download their details</small>
            </div>
            <div class="d-flex flex-wrap" style="gap: 8px;">
              <download-excel :data="json_data" :fields="json_fields" class="filter-toggle-btn" :escapeCsv="false"
                name="enrollment-officers.xls">
                <i class="fe fe-download mr-1"></i> Download
              </download-excel>
              <button type="button" class="filter-toggle-btn" @click="show = !show">
                <i class="fe mr-1" :class="show ? 'fe-x' : 'fe-user-plus'"></i> {{ show ? "Close" : "Add Officer" }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <section style="margin-top: -20px;">
        <div class="container pb-5">
          <!-- Add officer -->
          <div class="card shadow-sm form-card mb-4" v-show="show">
            <div class="form-card-header">
              <div class="section-number"><i class="fe fe-user-plus" style="font-size: 12px;"></i></div>
              <h6 class="mb-0 font-weight-bold text-white">Add an officer</h6>
            </div>
            <div class="card-body">
              <form @submit.prevent="registerUser">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="officerFirstname" class="small font-weight-bold text-secondary">First name</label>
                    <input id="officerFirstname" type="text" required class="form-control" v-model="register.firstname" />
                  </div>
                  <div class="form-group col-md-6">
                    <label for="officerLastname" class="small font-weight-bold text-secondary">Last name</label>
                    <input id="officerLastname" type="text" required class="form-control" v-model="register.lastname" />
                  </div>
                  <div class="form-group col-md-6">
                    <label for="officerPhone" class="small font-weight-bold text-secondary">Phone number</label>
                    <input id="officerPhone" v-phone type="text" required class="form-control" v-model="register.phone_number" />
                  </div>
                  <div class="form-group col-md-6">
                    <label for="officerEmail" class="small font-weight-bold text-secondary">Email</label>
                    <input id="officerEmail" type="email" required class="form-control" v-model="register.email" />
                  </div>
                  <div class="form-group col-md-6">
                    <label for="officerPassword" class="small font-weight-bold text-secondary">Password</label>
                    <input id="officerPassword" type="password" required class="form-control" autocomplete="new-password"
                      v-model="register.password" />
                  </div>
                  <div class="form-group col-md-6">
                    <label for="officerPasswordConfirm" class="small font-weight-bold text-secondary">Confirm password</label>
                    <input id="officerPasswordConfirm" type="password" required class="form-control" autocomplete="new-password"
                      v-model="register.password_confirmation" />
                  </div>
                </div>
                <div class="d-flex" style="gap: 8px;">
                  <button type="submit" class="btn btn-submit" :disabled="isLoading">
                    <i class="fe fe-check mr-1"></i> Add officer
                  </button>
                  <button type="button" class="btn btn-outline-secondary" @click="show = false">Cancel</button>
                </div>
              </form>
            </div>
          </div>

          <!-- Officers -->
          <div class="card shadow-sm table-card mb-4">
            <div class="form-card-header">
              <div class="section-number"><i class="fe fe-list" style="font-size: 12px;"></i></div>
              <h6 class="mb-0 font-weight-bold text-white flex-grow-1">Officers</h6>
              <span class="badge badge-light text-dark font-weight-bold">{{ meta.total }}</span>
            </div>
            <div class="table-responsive">
              <table class="table mb-0">
                <thead class="table-head">
                  <tr>
                    <th class="table-th">Name</th>
                    <th class="table-th">Email</th>
                    <th class="table-th">Phone</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="tpa in officers.data" :key="tpa.id" class="table-row">
                    <td class="font-weight-bold">{{ tpa.firstname }} {{ tpa.lastname }}</td>
                    <td>{{ tpa.email }}</td>
                    <td>{{ tpa.phone_number }}</td>
                  </tr>
                  <tr v-if="!(officers.data || []).length">
                    <td colspan="3" class="empty-state">
                      <i class="fe fe-users"></i>No officers yet. Use <b>Add Officer</b> to add one.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="card-body d-flex align-items-center justify-content-between flex-wrap" style="gap: 8px;"
              v-if="meta.last_page > 1">
              <small class="text-muted">Page {{ meta.current_page }} of {{ meta.last_page }}</small>
              <div class="d-flex" style="gap: 8px;">
                <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="meta.current_page == 1"
                  @click="gotoPrevious">
                  <i class="fe fe-chevron-left"></i> Previous
                </button>
                <button type="button" class="btn btn-sm btn-outline-secondary"
                  :disabled="meta.current_page == meta.last_page" @click="gotoNext">
                  Next <i class="fe fe-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="vld-parent">
          <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin
  let agency = JSON.parse(localStorage.getItem("agency"));

  export default {
    components: {
      Navbar,
      Loading,
    },
    data() {
      return {
        user: null,
        orgDetails: "",
        edit: false,
        show: false,
        isLoading: false,
        fullPage: true,
        officers: "",
        current_page: 1,
        register: {
          email: "",
          firstname: "",
          lastname: "",
          phone_number: "",
          state: "",
          agency_name: "",
          ward: "",
          services_offered: "",
          localgovt: "",
          address1: "",
          role: 0,
          password: "",
          password_confirmation: "",
        },
        json_fields: {
          Firstname: "firstname",
          Lastname: "lastname",
          "Email	": "email",
          "Phone Number": "phone_number",
        },
        json_data: [],
        json_meta: [
          [
            {
              key: "charset",
              value: "utf-8",
            },
          ],
        ],
      };
    },
    computed: {
      // Pagination info; empty until the officers have loaded
      meta() {
        return (this.officers && this.officers.meta) || { total: 0, current_page: 1, last_page: 1 };
      },
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/orgenrollment`)
        .then((response) => {
          this.tpas = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    methods: {
      gotoNext() {
        if (this.officers.meta.current_page != this.officers.meta.last_page) {
          this.current_page++;
          this.getOrgDetails();
        } else {
          this.$toasted.info("You have reached the Last Page", {
            position: "top-center",
            duration: 3000,
          });
        }
      },
      gotoPrevious() {
        if (this.officers.meta.current_page != 1) {
          this.current_page--;
          this.getOrgDetails();
        } else {
          this.$toasted.info("You have reached the First Page", {
            position: "top-center",
            duration: 3000,
          });
        }
      },
      registerUser() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/registerProvider", {
            email: this.register.email,
            phone_number: this.register.phone_number,
            agency_name: this.register.agency_name,
            firstname: this.register.firstname,
            lastname: this.register.lastname,
            state: agency.state,
            localgovt: agency.localgovt,
            type: "tpa_employee",
            password: this.register.password,
            password_confirmation: this.register.password_confirmation,
            enrolled_by: this.user.id,
            institutional_id: this.$route.params.id,
          })
          .then((response) => {
            let agent_id = response.data.data.id;

            // add Organization
            this.show = false;
            // console.log(response)
            this.axios
              .post("/api/v1/auth/enrollment_user", {
                orgenrol_id: this.$route.params.id,
                user_id: agent_id,
              })

              .then((response) => {
                console.log(response);
                this.getEmployees();
                this.clearIt();
                this.$toasted.info("Agent added Successfully!", {
                  position: "top-left",
                  duration: 5000,
                });
              })
              .catch((error) => {
                console.log(error.response);
                this.$toasted.error("Oops!", {
                  position: "top-left",
                  duration: 5000,
                });
              });
            // end of provider

            // console.log(response);
            this.isLoading = false;
            // localStorage.setItem('jwt',token);
            this.getEmployees();
          })
          .catch(() => {
            // console.log(error.response)
            this.isLoading = false;
            this.$toasted.error("Sign up not Successful", {
              position: "top-left",
              duration: 5000,
            });
          });
      },
      getOrgDetails() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/getOrgDetails/${this.$route.params.id}`)
          .then((response) => {
            this.orgDetails = response.data;
            // let org_id = response.data.id;

            // get officers
            this.axios
              .get(`/api/v1/auth/enrollment_user/${this.$route.params.id}`, {
                params: {
                  page: this.current_page,
                },
              })
              .then((response) => {
                this.officers = response.data;
                this.getTotalEmployees();
                // console.log(response)
              })
              .catch(() => {
                // console.error(error);
              });
            //end of get officers

            // console.log(response)
          })
          .catch(() => {
            // console.error(error);
          });
      },
      getEmployees() {
        this.axios
          .get(`/api/v1/auth/enrollment_user/${this.orgDetails.id}`)
          .then((response) => {
            this.officers = response.data;
            // console.log(response)
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getTotalEmployees() {
        console.log(this.officers.meta.total);
        console.log("this button is working");
        this.axios
          .get(`/api/v1/auth/enrollment_userall/${this.orgDetails.id}`)
          .then((response) => {
            // this.officers = response.data
            this.json_data = response.data.data;
            console.log(this.json_data);
            // console.log(response)
          })
          .catch((error) => {
            console.error(error);
          });
      },

      clearIt() {
        this.register.firstname = "";
        this.register.lastname = "";
        this.register.email = "";
        this.register.phone_number = "";
        this.register.password = "";
        this.register.password_confirmation = "";
      },
    },
    created() {
      this.getOrgDetails();
    },
  };
</script>
<style scoped>
@import "../reports/reports.css";
.btn-submit { background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%); color: #fff; border: none; border-radius: 8px; font-weight: 600; }
.btn-submit:hover:not(:disabled) { opacity: .88; color: #fff; }
.btn-submit:disabled { opacity: .55; }
</style>
